import { Navigate, useLocation } from 'react-router-dom';
import { mcpLoginReturnTo } from './mcpReturnTo';

export default function McpLoginGate() {
  const { pathname } = useLocation();
  // HashRouter stores the route after #; derive it from router state so a
  // delayed browser hash change cannot replace the pending request ID.
  const returnTo = mcpLoginReturnTo(window.location.pathname, window.location.search, `#${pathname}`);
  return <Navigate to={returnTo} replace />;
}